import React from "react";

function About() {
    return (
        <div>
<hr/>            
{/*
<div className="videotitle">Recent FiGPiN.com Releases</div>
<ul className="gallery mw-gallery-traditional">


<li className="gallerybox">
    <div className="setbox"><a title="Hello Kitty Series 3" href="https://figpin.com/collections/new-releases/products/hello-kitty-and-friends-mystery-series-3-each?ref=figpindb" target="_blank">
    <img alt="Hello Kitty Series 3" className="box-image" src="/figpin_hk3.png"/></a></div>
</li> 
    
<li className="gallerybox">
    <div className="setbox"><a title="Stitch" href="https://figpin.com/collections/shop-lilo-stitch" target="_blank">
    <img alt="Stitch" className="box-image" src="/figpin_stitch.png"/></a></div>
</li>

<li className="gallerybox">
    <div className="setbox"><a title="Naruto" href="https://figpin.com/products/naruto-uzumaki-1377" target="_blank">
    <img alt="Naruto" className="box-image" src="/figpin_naruto1377.png"/></a></div>
</li>

<li className="gallerybox">
    <div className="setbox"><a title="Pride" href="https://figpin.com/blogs/news/celebrate-pride-month-with-figpin" target="_blank">
    <img alt="Pride" className="box-image" src="/figpin_pride.png"/></a></div>
</li>

<li className="gallerybox">
    <div className="setbox"><a title="X-Men '97" href="https://figpin.com/collections/vendors?q=X-MEN+Animated&sort_by=created-descending" target="_blank">
    <img alt="X-Men '97" className="box-image" src="/figpin_xmen.png"/></a></div>
</li>


<li className="gallerybox">
    <div className="setbox"><a title="Solo Leveling" href="https://figpin.com/products/sung-jinwoo-1626?ref=figpindb" target="_blank">
    <img alt="Solo Leveling" className="box-image" src="/figpin_solo.png"/></a></div>
</li>

<li className="gallerybox">
    <div className="setbox"><a title="Dragonzord" href="https://figpin.com/products/dragonzord-x66?ref=figpindb" target="_blank">
    <img alt="Dragonzord" className="box-image" src="/box_dragonzord.png"/></a></div>
</li>

<li className="gallerybox">
    <div className="setbox"><a title="Jinbe" href="https://figpin.com/products/jinbe-x10?ref=figpindb" target="_blank">
    <img alt="Jinbe" className="box-image" src="/box_jinbe.png"/></a></div>
</li>

<li className="gallerybox">
    <div className="setbox"><a title="Megazord" href="https://figpin.com/products/megazord-x65?ref=figpindb" target="_blank">
    <img alt="Megazord" className="box-image" src="/box_megazord.png"/></a></div>
</li>

<li className="gallerybox">
    <div className="setbox"><a title="CyberPunk Edgerunners" href="https://figpin.com/collections/cyberpunk?ref=figpindb" target="_blank">
    <img alt="CyberPunk Edgerunners" className="box-image" src="/figpin_cyberpunk.png"/></a></div>
</li>

<li className="gallerybox">
    <div className="setbox"><a title="Gundam" href="https://figpin.com/collections/shop-gundam?ref=figpindb" target="_blank">
    <img alt="Gundam" className="box-image" src="/figpin_gundam.png"/></a></div>
</li>


<li className="gallerybox">
    <div className="setbox"><a title="One Piece" href="https://figpin.com/collections/shop-one-piece?ref=figpindb" target="_blank">
    <img alt="One Piece" className="box-image" src="/figpin_onepiece.png"/></a></div>
</li>

<li className="gallerybox">
    <div className="setbox"><a title="FNAF" href="https://figpin.com/collections/shop-five-nights-at-freddys?ref=figpindb" target="_blank">
    <img alt="FNAF" className="box-image" src="/figpin_fnaf.png"/></a></div>
</li>


<li className="gallerybox">
    <div className="setbox"><a title="Up" href="https://figpin.com/collections/up?ref=figpindb" target="_blank">
    <img alt="Up" className="box-image" src="/figpin_up.png"/></a></div>
</li>





<li className="gallerybox">
    <div className="setbox"><a title="PPG" href="https://figpin.com/products/the-powerpuff-girls-3-piece-box-set?ref=figpindb" target="_blank">
    <img alt="PPG" className="box-image" src="/figpin_ppg.png"/></a></div>
</li>
<li className="gallerybox">
    <div className="setbox"><a title="Rebels" href="https://figpin.com/collections/star-wars-rebels?ref=figpindb" target="_blank">
    <img alt="Rebels" className="box-image" src="/figpin_rebels.png"/></a></div>
</li>
<li className="gallerybox">
    <div className="setbox"><a title="MHA" href="https://figpin.com/collections/my-hero-academia?ref=figpindb&sort_by=created-descending" target="_blank">
    <img alt="MHA" className="box-image" src="/figpin_mha.png"/></a></div>
</li>

<li className="gallerybox">
    <div className="setbox"><a title="Encanto" href="https://figpin.com/collections/encanto?ref=figpindb" target="_blank">
    <img alt="Encanto" className="box-image" src="/figpin_encanto.png"/></a></div>
</li>

<li className="gallerybox">
    <div className="setbox"><a title="Naruto" href="https://figpin.com/products/naruto-shippuden-deluxe-box-set-2024-edition?ref=figpindb" target="_blank">
    <img alt="Naruto Box" className="box-image" src="/figpin_narutobox.png"/></a></div>
</li>

<li className="gallerybox">
    <div className="setbox"><a title="Return of the Jedi" href="https://www.figpin.com/shop/shop-all?license=star-wars?ref=figpindb" target="_blank">
    <img alt="Return of the Jedi" className="box-image" src="/figpin_swrotj.png"/></a></div>
</li>

<li className="gallerybox">
    <div className="setbox"><a title="Hall of Armor" href="https://figpin.com/products/hall-of-armor-deluxe-box-set-2024-edition?ref=figpindb" target="_blank">
    <img alt="Hall of Armor" className="box-image" src="/figpin_hallofarmor.png"/></a></div>
</li>

<li className="gallerybox">
    <div className="setbox"><a title="Scooby-Doo" href="https://figpin.com/collections/scooby-doo?ref=figpindb" target="_blank">
    <img alt="Scooby-Doo" className="box-image" src="/figpin_scoobydoo.png"/></a></div>
</li>

<li className="gallerybox">
    <div className="setbox"><a title="Quest" href="https://figpin.com/products/naruto-quest?ref=figpindb" target="_blank">
    <img alt="Quest" className="box-image" src="/figpin_quest.png"/></a></div>
</li>
</ul>
*/}
<p className="footer-text">FigpinDB is user supported. When you purchase through links on our site, we may earn an affiliate commission. FigpinDB is an unofficial fan site dedicated to FiGPiN pins. This site is in no way affiliated with FiGPiN Collect Awesome Inc or CMD Collectibles. All copyrighted material is the property of its respective owners. The use of this material is intended for entertainment-only purposes. No copyright infringement is intended at all and items will be removed if the owners wish. Please direct any questions, comments, additions or corrections to figpindb@gmail.com.</p>
        </div>
    );
}

export default About;